export default (base64) => {
  if (!base64) return null;
  const raw = window.atob(base64);
  const rawLength = raw.length;
  const binArray = new Uint8Array(new ArrayBuffer(rawLength));
  for (let i = 0; i < rawLength; i += 1) {
    binArray[i] = raw.charCodeAt(i);
  }
  return binArray;
};
